import { observer } from "mobx-react";
import { useStores } from "../../../../../stores";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

interface GrandChartGroupRouteProps {}

export const GrandChartGroupRoute = observer(({}: GrandChartGroupRouteProps) => {
	const { grandCharts } = useStores();

	const { selected } = grandCharts;
	const { groupId } = useParams<{ groupId: string }>();

	useEffect(() => {
		if (!groupId) {
			return;
		}
		if (selected.isLoading) {
			return;
		}
		if (!selected.id) {
			return;
		}
		const id = Number(groupId);
		if (!Number.isFinite(id)) {
			return;
		}
		const groupLesson = Object.values(selected.group_lessons_map)
			.flat()
			.find((item) => item.id === id);
		if (!groupLesson) {
			selected.clearSelectedGrandChartGroupLesson();
			return;
		}
		if (selected.selectedGrandChartGroupLesson.id === groupLesson.id) {
			return;
		}
		selected.setSelectedGrandChartGroupLesson(groupLesson);
	}, [groupId, selected.isLoading, selected.id, selected.group_lessons_map]);
	return null;
});
